import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Grid,
  Stack,
  Typography,
  TextField,
} from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import OAuthService from "src/app/auth/services/oAuthService";

export default function SendNotification(props) {
  const { open, onClose } = props;
  const [successMsg, setSuccessMsg] = useState();
  const [error, setError] = useState();
  const [abFile, setAbFile] = useState();
  const [abFileName, setAbFileName] = useState();
  const [value, setValue] = useState("");
  const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}`;
  const handleCommentChange = (event) => {
    setValue(event.target.value);
  };


  const loadABFile = async () => {
    try {
      if (props?.abFiles) {
        const file = await OAuthService.getPostPdf(
          url + `api/downloadAbFile/${props?.abFiles[0]?.id}`
        );

        const blob = new Blob([file?.data], { type: "application/pdf" });
        const blobUrl = URL.createObjectURL(blob);
        setAbFile(blob);
        setAbFileName(props?.abFiles[0]?.abFileName);
      }
    } catch (error) {
      setError(error?.message);
      console.error(error);
    }
  };

  useEffect(() => {
    if (open) {

      loadABFile();
    }
  }, [props?.open, open]);

  const onSendToCustomer = async () => {
    setSuccessMsg("");
    if (abFile) {
      const abFilePdf = new File([abFile], ".pdf");
      const formData = new FormData();
      formData.append("abPdf", abFilePdf);
      if (value?.trim()) {
        formData.append("comment", value);
      }
      try {
        await OAuthService.addFiles(
          url +
          `/api/sendAbNotification?abFileId=${props?.abFiles[0]?.id}&orderId=${props?.orderId}`,
          formData
        );
        setSuccessMsg("AB file send to customer successfully");
        onClose();
      } catch (error) {
        onClose();
        setError(error?.response?.data?.errorMessage || error.message);
      }
    }
  };

  useEffect(() => {
    props.handleSuccess(successMsg);
  }, [successMsg]);

  useEffect(() => {
    props.handleError(error);
  }, [error]);

  return (
    <>
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
        <DialogContent classes={{ root: "p-16 sm:p-24" }}>
          <DialogContentText id="alert-dialog-description" align="center">

            <Stack className="w-full mb-16">
              <Box className="flex justify-between">
                <Grid className="flex">
                  <div>
                    <FileCopyIcon
                      fontSize={"large"}
                      color="secondary"
                      sx={{ mt: 2 }}
                    />
                  </div>
                  <div>
                    <Typography fontSize="large" sx={{ ml: 1.5, mt: 2 }}>
                      {abFileName}
                    </Typography>
                  </div>
                </Grid>

              </Box>
            </Stack>
          </DialogContentText>
        </DialogContent>
        <DialogContent classes={{ root: "p-16 sm:p-24" }}>
          <Box sx={{ mb: 2 }}>
            <TextField
              id="outlined-textarea"
              label="Comment"
              placeholder="Write your comment here"
              multiline
              fullWidth
              rows={5}
              value={value}
              onChange={handleCommentChange}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={onSendToCustomer}
            autoFocus
          >
            Send to Customer
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            onClick={onClose}
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
